import * as React from 'react';
import { Dispatch } from 'redux';

import { BaseApiDeleteRequest } from '../generic/baseApiDeleteRequest';
import * as EntityNormalizers from '../normalizers/entityNormalizers';

export class DeleteParticipantsZipRequest extends BaseApiDeleteRequest<{}, EntityNormalizers.NormalizedEntity<{}>> {
  constructor(eventId: string, component: React.Component, dispatch: Dispatch) {
    super(component, dispatch);
    this.path = `/events/${eventId}/participants-zip`;
    this.normalizeMethod = result => result;
  }
}
